import {Layers, WalkOfShameLayers} from "./WalkOfShameLayers";
import {WalkOfShameGameConfig} from "../WalkOfShameGameConfig";
import {WalkOfShame} from "../WalkOfShame";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TimelineLite} from "gsap";

export class WalkOfShameSplitAnimation extends PIXI.Container {
    private _items: TimelineSprite[][] = [];

    constructor() {
        super();

        this.init();
        WalkOfShameLayers.getLayer(Layers.SPLIT_ANIMATION)!.addChild(this);
    }

    public playSplitAnimation(reel: number, symId: number, itemId: number): TimelineLite {
        const item: TimelineSprite = this._items[reel][itemId],
            symHeight: number = 148,
            baseY: number = (reel === 0 ? 162 : 89);

        if (reel > 0 && WalkOfShame.mToWild.ifFullSymExistsOnReel(reel)) {
            item.y = 360;
        } else {
            item.y = ((symId * symHeight) + (symHeight / 2) + baseY);
        }

        return item.getAnimationAutoShowHide(true, true);
    }

    private init(): void {
        for (let reel: number = 0; reel < WalkOfShameGameConfig.REELS_NUM; reel++) {
            this._items.push([]);
            const numItems: number = (reel === 0 ? 3 : 1),
                symWidth: number = 144;
            for (let ctr: number = 0; ctr < numItems; ctr++) {
                const item: TimelineSprite = new TimelineSprite(WalkOfShame.assetLoader.getTextures("splitAnimation/split_effect_000"));
                item.hide();
                item.scale.set(2);
                item.blendMode = PIXI.BLEND_MODES.ADD;
                item.anchor.set(0.5);
                item.x = ((reel * symWidth) + (symWidth / 2));

                this.addChild(item);
                this._items[reel].push(item);
            }
        }
    }
}